import { render, staticRenderFns } from "./rm-reisebasis.vue?vue&type=template&id=18bedcf0&scoped=true"
import script from "./rm-reisebasis.vue?vue&type=script&lang=js"
export * from "./rm-reisebasis.vue?vue&type=script&lang=js"
import style0 from "./rm-reisebasis.vue?vue&type=style&index=0&id=18bedcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bedcf0",
  null
  
)

export default component.exports